import Icon from '../components/Icon.vue'

Icon.register({
  underline: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.3 388.2C132.6 388.2 67.7 337.1 67.7 236.8V64H39.4C30.5 64 23.4 56.8 23.4 48V16C23.4 7.2 30.5 0 39.4 0H176.8C185.6 0 192.8 7.2 192.8 16V48C192.8 56.8 185.6 64 176.8 64H147.9V236.8C147.9 290.5 176.3 316.3 224.3 316.3 271.2 316.3 300.1 290.9 300.1 236.3V64H271.8C262.9 64 255.8 56.8 255.8 48V16C255.8 7.2 262.9 0 271.8 0H408.6C417.5 0 424.6 7.2 424.6 16V48C424.6 56.8 417.5 64 408.6 64H380.3V236.8C380.3 336.3 315.5 388.2 224.3 388.2zM16 448H432C440.8 448 448 455.2 448 464V496C448 504.8 440.8 512 432 512H16C7.2 512 0 504.8 0 496V464C0 455.2 7.2 448 16 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/underline.js
// module id = RZlX
// module chunks = 144